import OkC from "shared/util/OkcApi";
import { REVERSE_PRONOUN_LOOKUP } from "apps/profile_details/util/constants";
import { formatApiData } from "./helpers";
import isEmpty from "lodash/isEmpty";

const mergeResults = (results) => results.reduce((a, b) => ({ ...a, ...b }), {});

export function fetchProfileFields(userid) {
	// this fetches:
	// * the user's profile details
	// * all profile edit fields & values
	// * the user's WIW settings (to get their gender tags)
	const userDataCall = OkC.get(`profile/${userid}`);
	const parametersCall = OkC.get("profile/onboarding_parameters");
	const wiwCall = OkC.get("profile/wiw_parameters", { api: 1 });

	return Promise.all([userDataCall, parametersCall, wiwCall])
		.then(mergeResults)
		.catch(() => false);
}

export function saveData(data) {
	const formattedData = formatApiData(data);
	const calls = [];

	if ("isMetric" in formattedData) {
		const metricCall = OkC.post("/settings/metric", {
			api: 1,
			data: {
				metric: formattedData.isMetric,
			},
		});

		calls.push(metricCall);
	}

	delete (formattedData.isMetric);

	if ("gender_tags" in formattedData || "gender" in formattedData) {
		const genderCall = OkC.put("profile/me/gender", {
			api: 1,
			data: {
				genders: formattedData.gender_tags,
				includeInSearch: formattedData.gender,
			},
		});

		calls.push(genderCall);
	}

	// do a check here
	if (formattedData.gender_tags && formattedData.gender_tags.length > 1) {
		formattedData.gay_privacy = true;
		formattedData.orientation = "bisexual";
	}

	if ("name" in formattedData) {
		const nameCall = OkC.put("/profile/name", {
			api: 1,
			data: { name: formattedData.name },
		});

		calls.push(nameCall);
	}

	if ("pronouns" in formattedData) {
		let pronouns = formattedData.pronouns;

		if (REVERSE_PRONOUN_LOOKUP[formattedData.pronouns]) {
			pronouns = REVERSE_PRONOUN_LOOKUP[formattedData.pronouns];
		}

		const pronounsCall = OkC.post("/profile/me/pronouns", {
			api: 1,
			data: { pronouns },
		});

		calls.push(pronounsCall);
	}

	if ("education" in formattedData) {
		if (formattedData.education.schools) {
			const educationCall = OkC.post("/profile/me/education", {
				api: 1,
				data: {
					educationInfo: formattedData.education.schools,
				},
			});

			calls.push(educationCall);
		}
	}

	if ("occupation" in formattedData) {
		const occupationCall = OkC.post("/profile/me/occupation", {
			data: {
				title: formattedData.occupation.title,
				employer: formattedData.occupation.employer,
			},
		});

		calls.push(occupationCall);
	}

	if (formattedData.isStraightOnly) {
		const straightOnlyCall = OkC.put("profile/me/orientation_filter", {
			api: 1,
			data: {
				show_straight: 1,
				show_gay: 0,
				show_bi: 0,
			},
		});

		calls.push(straightOnlyCall);
		formattedData.orientation = "straight";
	}

	delete (formattedData.isStraightOnly);

	if (!isEmpty(formattedData)) {
		const profileCall = OkC.put("profile/me", {
			api: 1,
			data: formattedData,
		});

		calls.push(profileCall);
	}

	return Promise.all(calls)
		.then((res) => { return res; })
		.catch((err) => { return err; });
}



// WEBPACK FOOTER //
// ./src/apps/profile_details/util/web.js